import React, { FormEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import ApiEnvSelector from "../components/common/ApiEnvSelector";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { loginAdmin } from "../store/slices/authSlice";
import logoMain from "../assets/img/logo_main.png";

const LoginPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, loading, error } = useAppSelector((state) => state.auth);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/admin/members", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    await dispatch(loginAdmin({ username, password }));
  };

  return (
    <div className="login-page">
      <div className="login-brand-panel">
        <img className="login-brand-logo" src={logoMain} alt="나눔 로고" />
      </div>

      <div className="login-form-shell">
        <form className="login-card" onSubmit={onSubmit}>
          <div className="login-fields">
            <div className="login-field">
              <label htmlFor="login-username">아이디</label>
              <input
                id="login-username"
                type="text"
                placeholder="아이디를 입력해주세요"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                required
              />
            </div>
            <div className="login-field">
              <label htmlFor="password">비밀번호</label>
              <input
                id="password"
                type="password"
                placeholder="비밀번호를 입력해주세요."
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </div>
          </div>
          <div className="login-actions">
            {error && <p className="error-text">{error}</p>}
            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? "로그인 중..." : "로그인"}
            </button>
          </div>
          <ApiEnvSelector variant="compact" />
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
